'use clients';

import { Box, Flex } from '@chakra-ui/react';
import { FOOTER_CONFIG, Footer, NavbarContainer } from '@/modules/navigation';

import React, { type PropsWithChildren } from 'react';
import { Toaster } from '@packages/chakra-v3';
import type { NavigationMenuDocument } from '@/modules/sanity-studio/types';

type MainLayoutProps = {
	navigationMenu: NavigationMenuDocument;
} & PropsWithChildren;

const MainLayout = ({ navigationMenu, children }: MainLayoutProps) => {
	return (
		<Flex
			flexDir={'column'}
			minH={'100vh'}
			position={'relative'}
		>
			<NavbarContainer navigationMenu={navigationMenu} />
			<Box flex={1} pb={16}>
				{children}
			</Box>
			<Footer footerLinks={FOOTER_CONFIG} />
			<Toaster />
		</Flex>
	);
};

export default MainLayout;